import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class ReviewersColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.Reviewers
  declare readonly dataType: typeof MemexColumnDataType.Reviewers
  declare readonly userDefined: false
}
